/* eslint-disable array-callback-return */
/* eslint-disable dot-location */
/* eslint-disable prefer-const */
/* eslint-disable arrow-parens */
/* eslint-disable padding-line-between-statements */
/* eslint-disable keyword-spacing */
/* eslint-disable radix */
/* eslint-disable space-infix-ops */
/* eslint-disable space-before-blocks */
/* eslint-disable array-bracket-spacing */
/* eslint-disable semi */
/* eslint-disable arrow-spacing */
/* eslint-disable indent */
import React, { FC, useEffect, useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import './date-picker.css';
import { useSelector } from 'react-redux';

import {
    accountService,
    scheduleService
} from '../../../../../../service';
import { stringifyZone } from '../../../../../../utils';
import timezone from '../../../../../../utils/timezone';
import { Icon, IconAddCircle, IconRemove } from '../../../../base/icons';

import { TimePicker } from '@atlaskit/datetime-picker';
import moment from 'moment';
import 'moment-timezone';
import { debounce } from 'lodash/function';
import Spinner from '@atlaskit/spinner';

import ScheduledMeetingList from '../ScheduledMeeting/ScheduledMeetingList'
import SelectPopupTimeZone from '../SelectPopupTimeZone';


export interface GuestData {
    id: number,
    avatar: string,
    name: string,
    email: string,
}
export interface SchedCallProps {
    value: GuestData[],
    onChange: () => void,
    onClose: () => void,
    onSubmit?: () => void,
    user: Object
}
const SchedCall: FC<SchedCallProps> = ({ value, onChange, onClose, onSubmit, user }) => {

    const optionsTimezone = useMemo(() => timezone.map(item => {
        return {
            label: stringifyZone(item, 'GMT'),
            value: item.name
        };
    }), []);
    const { contact } = useSelector(state => state['features/settings']);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [isChangeDate, setIsChangeDate] = useState(true);
    const [startTime, setStartTime] = useState(moment().add(15, 'minutes')
        .format('HH:mm'));
    const [endTime, setEndTime] = useState(moment()
        .add(30, 'minutes')
        .format('HH:mm'));
    const [timeZone, setTimeZone] = useState(undefined);
    const [timeZoneValue, setTimeZoneValue] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [error, setError] = useState('');
    const [textInput, setTextInput] = useState('');
    const [listSuggest, setListSuggest] = useState(contact || []);

    const [contactList, setContactList] = useState([]);
    const [isValidTime, setIsValidTime] = useState(false);
    const [isNull, setIsNull] = useState(false);
    const [requiredCallName, setRequiredCallName] = useState('');
    const [callName, setCallName] = useState('');
    const [validDate, setValidDate] = useState('');
    const [editMeeting, setEditMeeting] = useState(false);
    const [selectEditMeeting, setSelectEditMeeting] = useState();
    const times: Array<string> = useMemo(() => ['00:00', '00:30', '1:00', '1:30', '2:00', '2:30', '3:00', '3:30', '4:00', '4:30', '5:00', '5:30', '6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '09:00', '09:30', '10:00', '10:15', '10:30', '10:45', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'], []);

    const handleAddGuest = value => {
        if (!contactList.some(item => item?.id === value?.id)) {
            setContactList([...contactList, value]);
        }
    };

    const formatDate = value => new Date(value).toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
    });

    const handleAddByEmail = value => {
        setListSuggest([]);
        const regEmail = /^([a-zA-Z0-9_\.\-+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (value?.trim() && regEmail.test(value.toLowerCase()
            .trim())) {
            setContactList([
                ...contactList,
                {
                    id: Math.floor(Math.random() * 1000),
                    email: value.trim(),
                    name: value.split('@')[0]
                }]);
            setTextInput('');
            setError('');
        } else {
            setError('Invalid email format');
        }
    };

    const handleSearch = value => {
        setError('');
        setTextInput(value);
        if (value.trim()) {
            debounceGetSuggestData(value);

            return;
        }
        setListSuggest(contact);
    };

    const getRestGuest = (data, itemAdded) => {
        const restArray = data.filter(item => {
            const rest = itemAdded.find(user => user?.id === item?.id);

            return item?.id !== rest?.id;
        });

        return restArray.filter((item, index) => index < 5 && item);
    };

    const debounceGetSuggestData = debounce(async value => {
        try {
            setIsLoading(true);
            const data = await accountService.getDataContact(value, 5);

            setListSuggest(data);
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    }, 500);

    const handleDate = dates => {
        const [time, end] = dates;
        if (isChangeDate) {
            setStartDate(time);
        } else {
            setEndDate(time);
        }

        setValidDate('');
    };
    const convertTime12to24 = (time12h) => {
        let [hours, minutes] = time12h.split(':');

        if (parseInt(hours) < 10 && hours.length < 2) {
            hours = `0${hours}`
        }

        return `${hours}:${minutes}`;
    }

    const add30minToStartTime = (time12h) => {
        // console.log(time12h)
        let [hours, minutes] = time12h.split(':');
        minutes = parseInt(minutes) + 30;
        if (minutes >= 60) {
            hours = parseInt(hours) + 1;
            minutes = minutes % 60
            if (minutes < 10) {
                minutes = `0${minutes}`
            }
            if (hours > 23) {
                hours = '00';
            }
        }

        // console.log(`${hours}:${minutes}`)
        return `${hours}:${minutes}`;
    }
    useEffect(() => {
        clearAllError()
        // eslint-disable-next-line array-bracket-spacing
        // eslint-disable-next-line indent
    }, [startTime, endTime])
    useEffect(() => {
        // console.log(startTime)
        if (startTime) {
            setEndTime(add30minToStartTime(startTime))
        }

    }, [startTime])
    const clearAllError = () => {
        setValidDate('');
        setRequiredCallName('')
    }
    const handleSubmit = async () => {
        try {
            setIsLoadingSave(true);
            if (moment(endDate).diff(moment(startDate), 'days') < 0) {
                setValidDate('Invalid date selected !');

                return;
            }
            if (!callName) {
                setRequiredCallName('Call name must not be empty !');

                return;
            }

            if (contactList.length === 0) {
                setIsNull(true);

                return;
            }
            setIsNull(false);
            if (!endTime || !startTime) {
                setIsValidTime(true);

                return;
            }
            setIsValidTime(false);
            onSubmit();

            const startTimeMoment = moment(`${startDate.toLocaleDateString('en-US')} ${convertTime12to24(startTime)}`)
            const endTimeMoment = moment(`${endDate.toLocaleDateString('en-US')} ${convertTime12to24(endTime)}`)

            const startTimeWithUTC = startTimeMoment.utc()
            const endTimeWithUTC = endTimeMoment.utc()

            if (startTimeWithUTC.isBefore()) {
                setValidDate('The start time is in the past.');
                return;

            } else if (endTimeWithUTC.isBefore()) {
                setValidDate('The end time is in the past.');
                return;

            } else if (endTimeWithUTC.diff(startTimeWithUTC) < 0) {
                setValidDate('The end time is before the start time.');
                return;
            }

            if (editMeeting) {

                await scheduleService.updateMeetingSchedule(selectEditMeeting._id, {
                    name: callName,
                    startTime: `${startTimeWithUTC.format('YYYY-MM-DDTHH:mm:ss.SSS')}`,
                    endTime: `${endTimeWithUTC.format('YYYY-MM-DDTHH:mm:ss.SSS')}`,
                    invitedUsers: contactList.map(item => item.id),
                    timeZoneValue,
                    meetingOwner: selectEditMeeting.meetingOwner
                }).then(() => {
                    onClose();
                });
            } else {
                await scheduleService.createMeetingSchedule({
                    name: callName,
                    startTime: `${startTimeWithUTC.format('YYYY-MM-DDTHH:mm:ss.SSS')}`,
                    endTime: `${endTimeWithUTC.format('YYYY-MM-DDTHH:mm:ss.SSS')}`,
                    invitedUsers: contactList.map(item => item.id),
                    timeZoneValue
                }).then(() => {
                    onClose();
                });
            }

        } catch (e) {
            console.log(e);
        } finally {
            setIsLoadingSave(false);
        }
    };
    const handleDelete = user => {
        const removeItem = contactList.filter(item => item.id !== user.id);

        setContactList(removeItem);
    };
    const renderItem = (item: GuestData, last = false, isDelete = false, handleSelect = () => {
    }) => {
        const defaultAvatar = 'https://dev.pantherconnect.me/images/gen-avatar.jpg';

        return (
            <div
                className={`o-sched-call-list-item ${last ? 'last' : ''}`}
                onClick={() => handleSelect(item)}>
                <img
                    className='o-sched-call-list-avt'
                    height={48}
                    src={item?.avatar ?? defaultAvatar}
                    width={48} />
                <div className='o-sched-call-list-title'>
                    <b>{item?.name ? item?.name : `${item?.firstName} ${item?.lastName}`}</b>
                    <p className='o-sched-call-list-email'>{item?.email}</p>
                </div>
                {isDelete && <div className='o-sched-call-list-delete'>
                    <div onClick={() => handleDelete(item)}>
                        <Icon
                            size={20}
                            src={IconRemove} />
                    </div>
                </div>}
            </div>
        );
    };

    useEffect(() => {
        setContactList(value);
    }, [value]);

    useEffect(() => {
        if (contact) {
            setListSuggest(contact);
        }
    }, [contact]);

    useEffect(() => {
        if (startDate.getDate() > endDate.getDate()) {
            setEndDate(startDate);
        }
    }, [startDate]);
    useEffect(() => {
        if (endDate.getDate() < startDate.getDate()) {
            setStartDate(endDate);
        }
    }, [endDate]);
    const onTimeZoneChange = (timeZoneData) => {

        //    console.log('onTimeZoneChange ' + timeZoneData);

        const currentTimeZone = timeZoneValue;
        if (currentTimeZone) {
            const startTimeConvetToChangeTimezone = moment.tz(`${startDate.toLocaleDateString('en-US')} ${convertTime12to24(startTime)}`, `${timeZoneValue}`).clone()
                .tz(timeZoneData.value)

            const convertedStartTime = startTimeConvetToChangeTimezone.format('HH:mm')


            const duration = moment.
                duration(startTimeConvetToChangeTimezone.diff(moment()
                    .clone()
                    .tz(timeZoneData.value)))
            if (duration.asMinutes() > 1) {
                setStartTime(convertedStartTime)
            }


        }

        // const endTimeWithUTC = moment.tz(`${endDate.toLocaleDateString('en-US')} ${convertTime12to24(endTime)}`, `${timeZoneValue}`).utc()
        // console.log('timeZoneData.value ' + timeZoneData.value);

        setTimeZoneValue(timeZoneData.value)
        setTimeZone(timeZoneData.label)
    }

    const onEditMeeting = (sheduledMeetingItem) => {
        setSelectEditMeeting(sheduledMeetingItem)
        setEditMeeting(true);
        const defaultTimezone = optionsTimezone.find(i => i.value.includes(sheduledMeetingItem.timeZone));
        onTimeZoneChange(defaultTimezone);
        setCallName(sheduledMeetingItem.meetingName);
        const participantsOfMeeting = []

        sheduledMeetingItem.participants.map(p => {
            const user = listSuggest.filter(item => item.id === p.user)
            if (user && user.length > 0) {
                participantsOfMeeting.push(user[0])
            }
        })
        setContactList(participantsOfMeeting)
        const scheduledStartTime = moment(sheduledMeetingItem.startDate).tz(sheduledMeetingItem.timeZone);
        const scheduledEndTime = moment(sheduledMeetingItem.endDate).tz(sheduledMeetingItem.timeZone);

        // console.log(scheduledStartTime.format(),'scheduledStartTime.startDate')
        setStartTime(scheduledStartTime.format('HH:mm'))
        setEndTime(scheduledEndTime.format('HH:mm'))
        setStartDate(new Date(scheduledStartTime.format()))
        setEndDate(new Date(scheduledEndTime.format()))

    }

    return (
        <div className='o-sched-call'>
            <div className='o-sched-call-wrapper'>
                <div className='o-sched-call-header'>
                    <div style={{ height: 30 }}>
                        <p className='o-sched-call-header-title '>Schedule a call</p>
                        <button
                            className='o-sched-call-header-close'
                            onClick={onClose}>
                            <img
                                height={32}
                                src='../../../images/close-sched.svg'
                                width={32} />
                        </button>
                    </div>
                    <div>
                        <input
                            className={'o-sched-call--input-call-name'}
                            onChange={e => {
                                setCallName(e.target.value);
                                setRequiredCallName(false);
                            }}
                            placeholder={'Call name'}
                            type='text'
                            value={callName ? callName : ''} />
                        {requiredCallName && <p className='o-sched-call--error'>{requiredCallName}</p>}
                    </div>
                </div>
                <div className='o-sched-call-body'>
                    <div
                        className='o-sched-call-content'>
                        <div className='o-sched-call-row'>
                            <div className='o-sched-call-calendar'>
                                <DatePicker
                                    disabledKeyboardNavigation={true}
                                    endDate={endDate}
                                    inline={true}
                                    minDate={new Date()}
                                    onChange={handleDate}
                                    selected={startDate}
                                    selectsRange={true}
                                    startDate={startDate} />
                                <div className={'time-picker-full'} >
                                    <div className='o-sched-call-calendar-time'>
                                        <div className={'dis-flex jus-between wid-full mv-2'}>
                                            <b className={'o-sched-call-calendar-time-label dis-flex ali-center'}>Time:</b>
                                            <div
                                                className={'o-sched-call-select-date'}
                                                onClick={() => setIsChangeDate(true)}
                                                style={{ borderColor: isChangeDate ? '#000' : '#d5d5d5' }}><p>{formatDate(startDate)}</p></div>
                                            <div className={'o-sched-call-calendar-time-start'}>
                                                <div className='o-sched-call-calendar-input'>
                                                    <TimePicker
                                                        id='timepicker'
                                                        isInvalid={isValidTime}
                                                        onChange={time => setStartTime(time)}
                                                        selectProps={{ classNamePrefix: 'timepicker-select' }}
                                                        testId={'timePicker'}
                                                        timeIsEditable={true}
                                                        times={times}
                                                        value={startTime} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={'dis-flex jus-between wid-full mv-2'}>
                                            <p
                                                className={'dis-flex ali-center'}
                                                style={{ minWidth: 50 }}>to</p>
                                            <div
                                                className={'o-sched-call-select-date'}
                                                onClick={() => setIsChangeDate(false)}
                                                style={{ borderColor: isChangeDate ? '#d5d5d5' : '#000' }}><p>{formatDate(endDate)}</p></div>
                                            <div className={'o-sched-call-calendar-time-start'}>
                                                <div className='o-sched-call-calendar-input'>
                                                    <TimePicker
                                                        backrgroundColor={'#000'}
                                                        id='timepicker'
                                                        isInvalid={isValidTime}
                                                        onChange={time => setEndTime(time)}
                                                        selectProps={{ classNamePrefix: 'timepicker-select' }}
                                                        testId={'timePicker'}
                                                        timeIsEditable={true}
                                                        times={times}
                                                        value={endTime} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={'time-picker-short'} >
                                    <div className={'time-picker-short--wrapper'} >
                                        <b className={'o-sched-call-calendar-time-label dis-flex ali-center'}>Time:</b>
                                        <div className={'o-sched-call-calendar-time-start'}>
                                            <div className='o-sched-call-calendar-input'>
                                                <TimePicker
                                                    backrgroundColor={'#000'}
                                                    id='timepicker'
                                                    isInvalid={isValidTime}
                                                    onChange={time => setEndTime(time)}
                                                    selectProps={{ classNamePrefix: 'timepicker-select' }}
                                                    testId={'timePicker'}
                                                    timeIsEditable={true}
                                                    times={times}
                                                    value={endTime} />
                                            </div>
                                        </div>
                                        <p
                                            className={'dis-flex ali-center'}
                                            style={{ marginLeft: 5 }}>to</p>
                                        <div className={'o-sched-call-calendar-time-start'}>
                                            <div className='o-sched-call-calendar-input'>
                                                <TimePicker
                                                    backrgroundColor={'#000'}
                                                    id='timepicker'
                                                    isInvalid={isValidTime}
                                                    onChange={time => setEndTime(time)}
                                                    selectProps={{ classNamePrefix: 'timepicker-select' }}
                                                    testId={'timePicker'}
                                                    timeIsEditable={true}
                                                    times={times}
                                                    value={endTime} />
                                            </div>
                                        </div>

                                    </div>
                                </div>


                                <div className='mt-15 mb-15 ph-20'>
                                    <SelectPopupTimeZone
                                        onChangeTimeZone={onTimeZoneChange}
                                        timeZone={timeZone} />
                                </div>

                            </div>
                            <div className='o-sched-call-calendar o-sched-call-add'>
                                <div className='o-sched-call-add-stt'>
                                    <b>Add guest</b>
                                </div>
                                <div className='o-sched-call-add-guest'>
                                    <div className='o-sched-call-add-guest-label'>
                                        <p>To:</p>
                                        <input
                                            className='o-sched-call-add-guest-input'
                                            onChange={value => handleSearch(value.target.value)}
                                            value={textInput} />
                                    </div>
                                    <button
                                        className='o-sched-call-add-guest-btn'
                                        onClick={() => handleAddByEmail(textInput)}>
                                        <Icon
                                            size={30}
                                            src={IconAddCircle} />
                                    </button>
                                </div>
                                <div className='o-sched-call-list'>
                                    {error && <p>{error}</p>}
                                    {
                                        isLoading
                                            ? <div className='o-sched-call-list-spinner'>
                                                <Spinner size={'large'} />
                                            </div>
                                            : getRestGuest(listSuggest, contactList).map((item, index) => renderItem(item, getRestGuest(listSuggest, contactList)?.length - 1 === index, false, () => handleAddGuest(item)))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className='o-sched-call-content'>
                        <div className='o-sched-call-row'>
                            <div className='o-sched-call-list o-sched-call-meeting'>
                                <ScheduledMeetingList
                                    onEditMeeting={onEditMeeting}
                                    user={user} />
                            </div>
                            <div className='o-sched-call-list o-sched-call-contact-list'>
                                <div className='o-sched-call-contact-list-title'>
                                    <h3>Participants list</h3>
                                </div>
                                {contactList.length === 0 && (
                                    <div className='o-sched-call-contact-list-empty'>
                                        <p>No participants</p>
                                    </div>
                                )}
                                {contactList.map((item, index) => renderItem(item, contactList.length - 1 === index, true))}
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div className={'o-sched-call-save'}>
                {isNull ? <div className={'o-sched-call-save-error'}>* You must to invite at least one participant.</div> : null}
                {validDate ? <div className={'o-sched-call-save-error'}>{validDate}</div> : null}
                <div
                    className={'o-sched-call-save-content'}
                    onClick={handleSubmit}>
                    {isLoadingSave
                        ? <Spinner />
                        : 'Save'
                    }
                </div>
            </div>
        </div>
    );
};

SchedCall.defaultProps = {
    value: [],
    onChange: () => { },
    onClose: () => { },
    onSubmit: () => { }
};

export default SchedCall;

